<template>
  <div>
    <Row>
      <Col span="12">房间id：{{modifyParams.xbedRoomId}}</Col>
      <Col span="12">业主：{{modifyParams.ownerName}}-{{modifyParams.ownerPhone}}</Col>
    </Row>
    <Row class-name="add-distance">
      <Col span="12">月份：{{modifyParams.curYearMonth}}</Col>
      <Col span="12">房间账单状态：{{['未结算','已结算','已打款'][modifyParams.imported]}}</Col>
    </Row>
    <!-- 提示 -->
    <p class="tips">* 导入结算表后、导入打款表前 可以修改 “房费原价~其它杂项费” 导入值</p>
    <p class="tips">* 导入打款表后 可以修改 “实际打款金额”，将影响下月 “上月结余” 值</p>
    <!-- 表格 -->
    <Row class-name="add-distance table">
      <!-- <InputNumber :min="0" :step="1" :precision="2" disabled style="width: 240px;" /> -->
      <Row class-name="table-header">
        <Col span="6">信息</Col>
        <Col span="6">系统值</Col>
        <Col span="6">导入值</Col>
        <Col span="6">操作</Col>
      </Row>
      <Row class-name="table-row" v-for="item in editMoneyGroup" :key="item.cname">
        <Col class-name="full-height" span="6">{{item.cname}}</Col>
        <Col class-name="full-height" span="6">￥ {{ item.systemPrice }}</Col>
        <Col class-name="full-height" span="6">
          ￥ <InputNumber 
            :min="0" 
            :disabled="item.isEditabled"
            v-model="item.importedPrice"
            style="width: 120px;" />
        </Col>
        <Col v-if="item.isShow" class-name="full-height" span="6">
          <Button type="primary" size="small" @click="changeMoney(item.index,'editMoneyGroup')">{{['保存','修改'][item.isEditabled - 0]}}</Button>
        </Col>
      </Row>
    </Row>
     <Row class-name="table"  v-for="itemDesc in editMiscellaneous" :key="itemDesc.cname">
        <Row class-name="table-row">
          <Col class-name="full-height" span="5">
            {{itemDesc.cname}}：
          </Col>
          <Col class-name="full-height" span="5">
            <Button type="primary" size="small" @click="changeMoney(itemDesc.index,'editMiscellaneous')">{{['保存','修改'][itemDesc.isEditabled - 0]}}</Button>
          </Col>
        </Row>
        <Row>
          <Input 
          type="textarea"
          v-model="itemDesc.desc"
          :disabled="itemDesc.isEditabled"
          ></Input>
        </Row>
      </Row>
  </div>
</template>

<script>
import API from "../../../api";
import Utils from "../../../utils";

export default {
 
  props:{
    modifyParams:{
      type: Object,
      default () {
        return {
          ownerName:'-',
          curYearMonth: '-',
          imported: 0,
          id:0
        }
      }
  }},
   
  data () {
    return {
      // 账单金额数据组
      editMoneyGroup:[ 
      ],
      // 编辑的杂项费说明
      editMiscellaneous:[],
      // 默认的编辑的目录  数组第一个是导入值    第二个是系统默认值   第三个费用名称  第四个 是否不可修改
    
      defaultEdit:[['checkRoomOriMoney','roomOriMoney','房费原价', true],
              ['checkOwnerDiscount','ownerDiscount','业主优惠', true],
              ['checkRoomSettleMoney','roomSettleMoney','结算房费（消费额）', true],
              ['checkChannelCommission','channelCommission','OTA佣金', true],
              ['checkOtherChannelExpenses','otherChannelExpenses','渠道活动费', true],
              // ['checkOtaPlatformMoney','otaPlatformMoney','渠道分销费'],
              ['checkOwnerPromotionExpense','ownerPromotionExpense','业主推广费', true],
              ['checkXbedPlatformMoney','xbedPlatformMoney','平台服务费', true],
              ['checkPromotionExpenseBack','promotionExpenseBack','推广费返还', true],
              ['checkDevFeeBack','devFeeBack','开发费返还'],
              ['otherIncome',null,'其它收入'],
              ['transactionFee',null,'第三方结算费'],
              ['invoiceTax',null,'税费'],
              ['groundSaleFee',null,'地面销售费用'],
              ['unoccupiedCommission',null,'基础导流佣金'],
              ['checkCleanMoney','cleanMoney','清洁单费'],
              ['checkConsumableMoney','consumableMoney','易耗品费'],
              ['checkLinenWashMoney','linenWashMoney','洗涤费'],
              ['checkOperatingExpenses','operatingExpenses','运营服务费'],
              ['checkSaleFeeBack','saleFeeBack','促销费返还'],
              ['miscellaneousExpenses',null,'其它杂项费'],
              ['lastMonthBalance',null,'上月结余', true],
              ['roomPresented',null,'本月可提现', true],
              ['actualTransferAmount',null,'实际打款金额', true]],

              
      // 杂项费说明
      defaultMiscellaneous:[['incomeDeclare','收入说明'],
                            ['miscellaneousExpensesDescription','杂项费说明']
      ]
    }
  },

  created(){
    this.token = Utils.findFromLocalStorage("vue-token"); 
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },

  watch: {
    modifyParams () {
      this.init()
    }
  },
  methods: {
    // 初始化参数
    init () {
      const transitParams = this.modifyParams;
      const editArray = this.defaultEdit;
      let miscellaneous= [];
      this.defaultMiscellaneous.map((item,index) => {
        miscellaneous.push({
          cname: item[1],                             
          desc: transitParams[item[0]] || '',   // 杂项费说明
          imported: transitParams.imported,
          isEditabled: true,
          index: index
        })
      });
      let transitArr = []   
      editArray.map((item,index) => {
        let isShow = !item[3];
        if( this.modifyParams.imported - 0 === 2 ){
          if(item[0] !== 'actualTransferAmount'){
            isShow = false;
          }else{
            isShow = true;
          }
        }
        let transitObj = {
          cname: item[2],                             //费用名
          systemPrice: ((transitParams[item[1]] || 0)/100).toFixed(2),         //系统值
          importedPrice: Number(transitParams[item[0]]/100 || 0),       //导入值
          imported: transitParams.imported,
          isEditabled: true,                   //是否不可以编辑  默认不可编辑
          isShow: isShow,           //是否显示操作按钮
          index: index                                //当前元素的标识符
        }
        transitArr.push(transitObj)
      })
      this.editMiscellaneous = miscellaneous;
      this.editMoneyGroup = transitArr;
    },

    /** 
     * 修改并提交数据
     * @param index 触发修改的对象的标识符 
     * @param type 触发的修改的类型，费用修改，说明修改
     */
    async changeMoney (index, type) {
      const transitObj = type === 'editMoneyGroup' ? this.editMoneyGroup[index] : this.editMiscellaneous[index];
      const btnStatus = transitObj.isEditabled;
      const defaultEidt = type === 'editMoneyGroup' ? this.defaultEdit : this.defaultMiscellaneous;
      if( transitObj.imported < 1 ){
        this.$Notice.info({
          title:'无法修改',
          desc: `请先导入${transitObj.cname}金额`
        })
        return
      }
      if( type === 'editMoneyGroup' && typeof transitObj.importedPrice !== 'number' ){
          this.$Notice.error({
            title:'输入错误',
            desc: '请输入正确的金额'
          })
        }
      if( !btnStatus ){
        const params = {
              id:this.modifyParams.id, 
              [defaultEidt[index][0]]: type === 'editMoneyGroup' ? transitObj.importedPrice*100 : transitObj.desc
            }
            console.info(params);
        try{
          const responData = await API.omsAPI[this.env].analysis.updateReRoomMonthIncome(params,this.token);
          console.info('success',responData);
          this.$Notice.success({
            title:'修改成功',
            desc: '修改成功'
          })
        }catch(e){
          console.info(e)
        }
      }
      transitObj.isEditabled = !btnStatus;
    }
  },
  filters: {
    importedCurrency (money) {
      return Number(money) && (money % 100) === 0 ? 0 : money.toFixed(2)
    },
    systemCurrency (money) {
      return Number(money) ? money.toFixed(2) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  color: #ed3f14;
}
.add-distance {
  margin: 10px 0;
}
.full-height {
  min-height: 34px;
}
.table {
  $table-row-height: 34px;

  border: 1px solid #dddee1;
  text-align: center;
  font-size: 14px;
  .table-header {
    height: $table-row-height;
    line-height: $table-row-height;
    font-weight: bold;
    background-color: #f8f8f9;
  }
  .table-row {
    padding: 10px 0;
    line-height: $table-row-height;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/report/owner-revenue/edit-room-money.vue